import { filterMaybe } from '@edge/spark/utils'
import type { OtherUsersDashboardsQuery, UserDashboardsQuery } from '../generated/graphql'

export const pickDashboards = (data?: OtherUsersDashboardsQuery | UserDashboardsQuery): string[] | undefined => {
    if (!data) {
        return undefined
    }

    if ('administrator' in data) {
        const otherUsersDashboards = data.administrator?.user?.dashboards?.filter(filterMaybe)
        return otherUsersDashboards
    }

    if ('user' in data) {
        const ownUserDashboards = data.user?.dashboards?.filter(filterMaybe)
        return ownUserDashboards
    }

    return undefined
}
